import { Dimensions } from 'react-native';

const WW = Math.round(Math.min(Dimensions.get('window').width, 50 * 16));
const WH = Math.round(Math.min(Dimensions.get('window').height, 70 * 16));

export { WW, WH };
